export default "__VITE_ASSET__cec036d6__"